import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { BehaviorSubject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-collapsible-drawer',
  templateUrl: './collapsible-drawer.component.html',
  styleUrls: ['./collapsible-drawer.component.scss'],
})
export class CollapsibleDrawerComponent implements OnInit {
  @Input() alwaysExpanded = false;
  @Input() beta = false;
  @Output() drawerToggled = new EventEmitter<boolean>();

  public isOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public isMobile$ = this.deviceDetectionService.isMobileViewport();
  private touches$ = new BehaviorSubject<{ start: TouchEvent; end: TouchEvent }>({ start: null, end: null });
  private mobileTouchesOnOpenDrawer$ = this.isMobile$.pipe(
    filter((isMobile) => isMobile),
    switchMap(() => this.isOpen$.pipe(filter((isOpen) => isOpen))),
    switchMap(() => this.touches$.pipe(filter((touches) => Boolean(touches.start) && Boolean(touches.end))))
  );

  @HostListener('touchstart', ['$event']) onSwipeStart($event) {
    this.touches$.next({ start: $event, end: null });
  }

  @HostListener('touchend', ['$event']) onSwipeEnd($event) {
    this.touches$.next({ start: this.touches$.value.start, end: $event });
  }

  constructor(private deviceDetectionService: DeviceDetectionService) { }

  ngOnInit(): void {
    this.isMobile$.subscribe((isMobile) => {
      if (isMobile) {
        this.isOpen$.next(false);
      }
    });

    this.mobileTouchesOnOpenDrawer$.subscribe(({ start, end }) => {
      if (this.isSwipeDown(start, end)) {
        this.toggleDrawer(false);
      }
    });
    this.isOpen$.subscribe((isOpen) => {
      this.drawerToggled.emit(isOpen);
    });
  }

  private isSwipeDown(start: TouchEvent, end: TouchEvent): boolean {
    return start.touches[0].clientY - end.changedTouches[0].clientY < -400;
  }

  public toggleDrawer(forcedValue = null): void {
    const newVal = forcedValue === null ? !this.isOpen$.value : forcedValue;
    this.isOpen$.next(newVal);
  }
}
